var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Configuração do sistema"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('rkm-button',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$refs.Form.save()}}},[_vm._v(" Salvar ")])]},proxy:true}])},[_c('rkm-layout-content',[_c('Form',{ref:"Form"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }